import { Outlet } from 'react-router';
import { styled } from '@mui/material/styles';
import { LogoWithText } from '../components/Logo';

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

type Props = {
  disabledLink?: boolean;
};

export default function LogoOnlyLayout({ disabledLink }: Props) {
  return (
    <>
      <HeaderStyle>
        <LogoWithText disabledLink={disabledLink} />
      </HeaderStyle>
      <Outlet />
    </>
  );
}
